module.exports = __webpack_public_path__ + "static/Sound Icon-8babc791bd4a866bb898ed2f7925afdc.png";